<template>
  <fragment>
    <hero-header page-name="Karrier" hero-title="Állásajánlatok"/>
    <!-- AKTUÁLIS ÁLLÁSOK SECTION START -->
    <v-container class="my-5">
      <fancy-headline title="Aktuális állásaink" />
      <v-row class="my-10" v-if="$store.state.jobsStore.jobs.length">
        <v-col cols="12" sm="4" md="3" v-for="(job, index) in $store.state.jobsStore.jobs" :key="index">
          <job-card2 v-bind:job="job" />
        </v-col>
      </v-row>
      <v-row class="my-10" v-else>
        <v-col cols="12" sm="12" md="12">
          <p align="center">Jeleneleg nincs nyitott pozíciónk!</p>
        </v-col>
      </v-row>
    </v-container>
    <!-- AKTUÁLIS ÁLLÁSOK SECTION END -->
    <!-- CONTACT FORM SECTION START -->
    <v-container class="my-5">
      <v-row>
        <fancy-headline title="Küldd el önéletrajzod és visszahívunk" name="Más terület érdekel?" />
        <contact-form-job-application />
      </v-row>
    </v-container>
    <!-- CONTACT FORM SECTION END -->
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
// import jobCard from '../components/jobCard.vue';
import jobCard2 from '@/components/jobCard2.vue';
import fancyHeadline from '../components/fancyHeadline.vue';
import contactFormJobApplication from '../components/contactFormJobApplication.vue';
import { JOBS_GET_ALL } from '../store/actions.type';
import { JOBS_SET_SELECTFIELDOPTIONS } from '../store/mutations.type';

export default {
  name: 'careerJobOffers',
  components: {
    heroHeader, jobCard2, fancyHeadline, contactFormJobApplication,
  },
  async beforeMount() {
    this.getJobList();
    // this.openPositions = await this.listOpenPositions();
  },
  data() {
    return {
      openPositions: [],
    };
  },
  methods: {
    async listOpenPositions() {
      try {
        const response = await this.$store.dispatch(JOBS_GET_ALL);
        if (!response.error && response.data) {
          return response.data;
        }
        return [];
      } catch (err) {
        return [];
      }
    },
    async getJobList() {
      this.$store.commit(JOBS_SET_SELECTFIELDOPTIONS);
    },
  },
};
</script>

<style scoped>

</style>
